<script lang="ts">
  import { EMOJI_SIZE } from "./EmojiPicker.svelte";
  import { fade } from "svelte/transition";
  import type { Emoji } from "./types";

  export let showSkinTones = false;
  export let skinIndex: number;
  export let emojisLabels: Emoji[];

  $: skinTones = emojisLabels.find((emoji) => emoji.name === "Thumbs Up")?.skins!;
</script>

<div
  class="flex min-w-fit items-center justify-center gap-[8.5px] px-1 transition-[width] duration-[250ms] ease-out"
  class:w-[218px]={showSkinTones}
  class:w-[36px]={!showSkinTones}
>
  {#if showSkinTones && skinTones?.length}
    {#each skinTones as skin, index (skin)}
      <button
        type="button"
        class="ov-focus relative flex h-[28px] w-[28px] items-center justify-center rounded p-1 transition-colors duration-75 after:rounded hover:cursor-pointer hover:bg-black/15 dark:hover:bg-white/15"
        on:click|stopPropagation|preventDefault={() => {
          skinIndex = index;
          showSkinTones = !showSkinTones;
        }}
        in:fade|global={{
          duration: 200,
          delay: (skinTones.length - index) * 25,
        }}
      >
        {skin.native}
      </button>
    {/each}
  {:else if !showSkinTones && skinTones?.length}
    <button
      type="button"
      aria-label="show skin tone selector"
      style={`width: ${EMOJI_SIZE}px; height: ${EMOJI_SIZE}px;`}
      class="ov-focus relative flex items-center justify-center rounded p-1 after:rounded"
      on:click|stopPropagation|preventDefault={() => (showSkinTones = !showSkinTones)}
    >
      {skinTones?.[skinIndex].native}
    </button>
  {/if}
</div>
